import { render, staticRenderFns } from "./ratesSetup.vue?vue&type=template&id=cabba638&scoped=true"
import script from "./ratesSetup.vue?vue&type=script&lang=js"
export * from "./ratesSetup.vue?vue&type=script&lang=js"
import style0 from "./ratesSetup.vue?vue&type=style&index=0&id=cabba638&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cabba638",
  null
  
)

export default component.exports